import { combineReducers } from "redux";
import mainMenu from './cms.reducer';

const reducer = combineReducers({    
    mainMenu
});

export default reducer;